export const lista = [
    {
        id: 1,
        name: "Acão",
        img: "https://sekailist.vercel.app//acao.webp",
        genreName: "acao",
    },
    {
        id: 2,
        name: "Aventura",
        img: "https://sekailist.vercel.app//aventura.webp",
        genreName: "aventura",
    },
    {
        id: 5,
        name: "Avant Garde",
        img: "https://sekailist.vercel.app//avant-garde.webp",
        genreName: "avant-garde",
    },
    {
        id: 7,
        name: "Mistério",
        img: "https://sekailist.vercel.app//misterio.webp",
        genreName: "misterio",
    },
    {
        id: 37,
        name: "Sobrenatural",
        img: "https://sekailist.vercel.app//sobrenatural.webp",
        genreName: "sobrenatural",
    },
    {
        id: 4,
        name: "Comédia",
        img: "https://sekailist.vercel.app//comedia.webp",
        genreName: "comedia",
    },
    {
        id: 8,
        name: "Drama",
        img: "https://sekailist.vercel.app//drama.webp",
        genreName: "drama",
    },
    {
        id: 9,
        name: "Fan Service",
        img: "https://sekailist.vercel.app//fanservice.webp",
        genreName: "fan-service",
    },
    {
        id: 10,
        name: "Fantasia",
        img: "https://sekailist.vercel.app//fantasia.webp",
        genreName: "fantasia",
    },
    {
        id: 14,
        name: "Terror",
        img: "https://sekailist.vercel.app//terror.webp",
        genreName: "terror",
    },
    {
        id: 40,
        name: "Psicológico",
        img: "https://sekailist.vercel.app//psicologico.webp",
        genreName: "psicologico",
    },
    {
        id: 22,
        name: "Romance",
        img: "https://sekailist.vercel.app//romance.webp",
        genreName: "romance",
    },
    {
        id: 24,
        name: "Sci-Fi",
        img: "https://sekailist.vercel.app//scifi.webp",
        genreName: "sci-fi",
    },
    {
        id: 36,
        name: "Slice of Life",
        img: "https://sekailist.vercel.app//sliceoflife.webp",
        genreName: "slice-of-life",
    },
    {
        id: 30,
        name: "Sport",
        img: "https://sekailist.vercel.app//sport.webp",
        genreName: "sport",
    },
    {
        id: 42,
        name: "Seinen",
        img: "https://sekailist.vercel.app//seinen.webp",
        genreName: "seinen",
    },
]